import { useEffect, useSyncExternalStore } from 'react'

import { onboardingDataStore } from './OnboardingDataStore'

/**
 * React hook to consume shared onboarding data.
 *
 * - Reads from OnboardingDataStore (cross-chunk singleton)
 * - Triggers fetch if data is not yet in the store
 * - Re-renders when data changes (via useSyncExternalStore)
 *
 * @param key   Unique cache key (e.g. 'request:123')
 * @param fetcher  Async function to fetch data if not cached
 * @param enabled  Whether to fetch (default true). When false, returns undefined without fetching.
 */
export function useOnboardingData<T>(
  key: string,
  fetcher: () => Promise<T>,
  enabled = true
): T | undefined {
  useSyncExternalStore(onboardingDataStore.subscribe, onboardingDataStore.getVersion)

  useEffect(() => {
    if (!enabled) return
    onboardingDataStore.fetch(key, fetcher)
  }, [key, enabled])

  return onboardingDataStore.get<T>(key)
}
